import React from 'react';
import { types } from 'helpers';
import { Loading } from 'components';

const List = React.lazy(() => import('./_Transactions'));

const Transfers = () => {

    return (
        <React.Fragment>
            <React.Suspense fallback={<Loading spinning={true} />}>
                <List type={types.TrxTypes.CREDIT} />
            </React.Suspense>
        </React.Fragment>
    );
}

export default Transfers;